import isEmail from 'validator/lib/isEmail';
import isEmpty from 'validator/lib/isEmpty';

const loginSchema = {
  email: {
    type: String,
    required: true,
    validate: {
      message: 'loginSchema.invalid-email',
      validator: value => isEmail(value),
    },
  },
  password: {
    type: String,
    required: true,
    validate: {
      message: 'loginSchema.empty-password',
      validator: value => !isEmpty(value),
    },
  },
};

export default loginSchema;



// WEBPACK FOOTER //
// ./src/schemas/login.js